module.exports = __webpack_public_path__ + "img/default3.fa5a5d50.svg";